import React from 'react'
import { CopyText, Site } from '@chegg/wt-checkout'
import { supportPageLinks } from '@chegg-wt/core/constants/supportPageLinks'
import { Config } from '@chegg-wt/core/config'

const getLegalNode = (site: Site): React.ReactNode => {
  return (
    <>
      You can cancel your subscription at any time by visiting our{' '}
      <a
        href={supportPageLinks[site]}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="SupportPage"
      >
        Support Page
      </a>{' '}
      and completing the steps to cancel or email{' '}
      <a
        href="mailto:wtsupport@chegg.com"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="SupportEmail"
      >
        wtsupport@chegg.com
      </a>
      . Cancellations will take effect at the end of the current billing cycle. Your
      subscription includes up to 30 Expert Checks per billing period. Expert Checks are
      limited to papers ${Config.paperCheckWordCountLimit} words or less and can only be
      submitted one paper at a time.
    </>
  )
}

export const getCheckoutCopy = (
  hasFreeTrial: boolean,
  price: string,
  site: Site
): CopyText | undefined => {
  if (!hasFreeTrial) {
    const legalBlocks: React.ReactNode[] = []

    legalBlocks.push(
      `By clicking "Start your subscription," you will automatically be enrolled in a monthly subscription.
        You authorize Chegg to automatically charge your payment method on file ${price}/per month (+ tax if applicable) each month until you cancel.
        You will be billed the monthly subscription cost starting on the day your subscription begins.
        Subscription fees are not refundable and unused subscription benefits expire and do not roll over to subsequent months.`
    )
    legalBlocks.push(getLegalNode(site))
    return {
      freeTrialText: `Start your ${price}/mo subscription*`,
      cancelSubscriptionText: 'Cancel anytime',
      legalTextBlocks: legalBlocks,
      placeOrderText: 'Start your subscription',
    }
  }
  return undefined
}
